export default __webpack_public_path__ + "static/media/P20009.35313446.png";